export default {
  methods: {
    isHotlineTriggerPhrase: (phrase) => {
      const phrases = [
        'TURBO',
        'TURBOCHARGER',
        'TURBODMYCHADLO',
        'TURBOLADER',
        'τούρμπο',
        'ΤΟΥΡΜΠΙΝΑ',
        '涡轮',
        '涡轮增压器',
        'TURBOCOMPRESOR',
        'TURBOAHDIN',
        'TURBOCOMPRESSEUR',
        'TURBÓ',
        'TURBÓFELTÖLTŐ',
        'TURBOCOMPRESSORE',
        'TURBOSPRĘŻARKA',
        'TURBOSUFLANTA',
        'ТУРБО',
        'ТУРБОКОМПРЕССОР',
        'ТУРБОКОМПРЕСОР',
        'TURBOLADDARE',
        'TURBOLADARE',
        'TURBOCOMPRESSOR',
        'ТУРБО-КОМПРЕСОР',
      ];
      return phrases.some((element) => element.toLowerCase() === phrase.toLowerCase()); // case insensitive method
    },
  },
};
